import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { makeStyles } from "@mui/styles";
import Drawer from "@mui/material/Drawer";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  RoleCheck,
  userSelector,
  clearState,
} from "../../components/redux/modules/globalSlice";
import {
  togglePlannerSidebar,
  toggleTrainSidebar,
  toggleTruckSidebar,
  toggleShipSidebar,
  toggleCustomerSupportSidebar,
  toggleMarketingSidebar,
  toggleContainerRepairSidebar,
  toggleFinancialSidebar,
  toggleSettingSidebar,
} from "../redux/modules/globalSlice";
import Logo from "../../images/SriTrangLogo.png";
import api from "../../components/services/api";
import { Divider } from "@mui/material";
const drawerHeight = "100%";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    height: drawerHeight,
    backgroundColor: "#AFF",
  },
}));

export default function SideBar(props) {
  const classes = useStyles();
  const {
    sidebarOpen,
    sidebarCustomerSupportOpen,
    sidebarMarketingOpen,
    sidebarShipOpen,
    sidebarPlannerOpen,
    sidebarTruckOpen,
    sidebarTrainOpen,
    sidebarContainerRepairOpen,
    sidebarFinancialOpen,
    sidebarSetttingOpen,
  } = useSelector((state) => state.global.sidebar);
  const dispatch = useDispatch();
  const RoleID = localStorage.getItem("RoleID");
  const [RoleData, setRoleData] = useState([]);

  const handleDrawerClose = () => {
    props.onDrawerClose();
  };

  const CheckRole = async () => {
    const params = {
      roleId: RoleID,
    };
    try {
      const res = await api.post("api/auth/checkrole", params);
      const data = await res.data
      setRoleData(data);
      dispatch(RoleCheck(data));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    CheckRole();
  }, []);

  return (
    <Drawer
      open={sidebarOpen}
      sx={{
        width: sidebarOpen ? drawerWidth : 0,
        flexShrink: 0,
        // "& .MuiDrawer-paper": {
        //   width: drawerWidth,
        //   boxSizing: "border-box",
        // },
      }}
      variant='persistent'
      anchor="left"
    >
      <div
      // className="sideNav"
      >
        {/* Core theme CSS (includes Bootstrap)*/}
        {/* <link href="css/styles.css" rel="stylesheet" /> */}
        <div className="d-flex" id="wrapper">
          {/* Sidebar*/}
          <div className="border-end bg-white" id="sidebar-wrapper">
            <div className="sidebar-heading border-bottom bg-light">
              <img src={Logo} alt="logo" id="logo" className="size" />
              {/* <span
                id="sidebarToggle"
                className="material-icons-outlined btn"
                onClick={handleDrawerClose}
              >
                menu
              </span> */}
            </div>
            <div className="list-group list-group-flush">
              {RoleData?.find((x) => x.ActionNo === "A012") && (
                <NavLink
                  className="list-group-item list-group-item-action list-group-item-light p-3"
                  exact={true}
                  activeClassName="is-active"
                  to="/Dashboard/Dashboard"
                  style={{ display: "flex", flexDirection: "row", }}
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    dashboard
                  </span>
                  Dashboard
                </NavLink>
              )}
              {RoleData?.find((x) => x.ActionNo === "A077") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  onClick={() =>
                    dispatch(
                      toggleCustomerSupportSidebar(!sidebarCustomerSupportOpen)
                    )
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    inventory
                  </span>
                  Customer Support
                  {sidebarCustomerSupportOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarCustomerSupportOpen ? (
                <div>
                  {RoleData?.find((x) => x.ActionNo === "A019") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/CustomerSupport/Forwarder"
                    >
                      Forwarder
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A017") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/CustomerSupport/Customer"
                    >
                      Customer
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A021") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/CustomerSupport/Factory"
                    >
                      Factory
                    </NavLink>
                  )}
                </div>
              ) : null}
              {RoleData?.find((x) => x.ActionNo === "A084") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  onClick={() =>
                    dispatch(toggleMarketingSidebar(!sidebarMarketingOpen))
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    storefront
                  </span>
                  Marketing
                  {sidebarMarketingOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarMarketingOpen ? (
                <div>
                  {RoleData?.find((x) => x.ActionNo === "A014") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/CustomerSupport/Quotation"
                    >
                      Quotation
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A023") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/CustomerSupport/SaleOrder"
                    >
                      Sale Order
                    </NavLink>
                  )}
                </div>
              ) : null}
              {RoleData?.find((x) => x.ActionNo === "A085") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  // onClick={() => toggle360(!Open360)}
                  onClick={() =>
                    dispatch(togglePlannerSidebar(!sidebarPlannerOpen))
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    receipt_long
                  </span>
                  Planner
                  {sidebarPlannerOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarPlannerOpen ? (
                <div>
                  {/* {RoleData?.find((x) => x.ActionNo === "A024") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Planner/Planning"
                    >
                      Planning
                    </NavLink>
                  )} */}

                  {RoleData?.find((x) => x.ActionNo === "A030") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/ShipPlanning"
                    >
                      Ship Planning
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A028") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/TrainPlanning"
                    >
                      Train Planning
                    </NavLink>
                  )}
                  {/* <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/AddMember"
                    
                  >
                    Truck Schedule
                  </NavLink> */}
                  {RoleData?.find((x) => x.ActionNo === "A030") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/TruckPlanning"
                    >
                      Truck Planning
                    </NavLink>
                  )}
                  {/* {RoleData?.find((x) => x.ActionNo === "A026") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Planner/ContainerList"
                    >
                      Container List
                    </NavLink>
                  )} */}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Planner/ContainerManagement"
                  >
                    Container Management
                  </NavLink>
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Planner/Stock"
                  >
                    Stock
                  </NavLink>
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Planner/CargoTracking"
                  >
                    Cargo Tracking
                  </NavLink>
                </div>
              ) : null}
              {RoleData?.find((x) => x.ActionNo === "A086") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  onClick={() =>
                    dispatch(toggleTruckSidebar(!sidebarTruckOpen))
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    local_shipping
                  </span>
                  Truck
                  {sidebarTruckOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarTruckOpen ? (
                <div>
                  {RoleData?.find((x) => x.ActionNo === "A032") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Truck/WorkOrder"
                    >
                      Work Order
                    </NavLink>
                  )}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Truck/TruckSchedule"
                  >
                    Truck Schedule
                  </NavLink>
                  {/* {RoleData?.find((x) => x.ActionNo === "A034") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Truck/ContainerList"
                    >
                      Container List
                    </NavLink>
                  )} */}
                  {/* {RoleData?.find((x) => x.ActionNo === "A036") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Truck/E.I.R"
                    >
                      E.I.R
                    </NavLink>
                  )} */}
                  {RoleData?.find((x) => x.ActionNo === "A036") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Truck/InboundTruck"
                    >
                      Inbound
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A036") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Truck/OutboundTruck"
                    >
                      Outbound
                    </NavLink>
                  )}
                </div>
              ) : null}
              {RoleData?.find((x) => x.ActionNo === "A087") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  // onClick={() => toggleAdmin(!OpenAdmin)}
                  onClick={() =>
                    dispatch(toggleTrainSidebar(!sidebarTrainOpen))
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    train
                  </span>
                  Train
                  {sidebarTrainOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarTrainOpen ? (
                <div>
                  {RoleData?.find((x) => x.ActionNo === "A038") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Train/TrainSchedule"
                    >
                      Train Schedule
                    </NavLink>
                  )}
                  {/* {RoleData?.find((x) => x.ActionNo === "A041") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Train/ContainerList"
                    >
                      Container List
                    </NavLink>
                  )} */}

                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Train/Inboundtrain"
                  >
                    Inbound
                  </NavLink>
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Train/Outboundtrain"
                  >
                    Outbound
                  </NavLink>

                </div>
              ) : null}
              {RoleData?.find((x) => x.ActionNo === "A088") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  onClick={() => dispatch(toggleShipSidebar(!sidebarShipOpen))}
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    directions_boat
                  </span>
                  Ship
                  {sidebarShipOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarShipOpen ? (
                <div>
                  {/* {RoleData?.find((x) => x.ActionNo === "A043") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Ship/Hightofwater"
                    >
                      Hight Of Water
                    </NavLink>
                  )} */}
                  {RoleData?.find((x) => x.ActionNo === "A045") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Ship/ShipSchedule"
                    >
                      Ship Schedule
                    </NavLink>
                  )}

                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Ship/Inbound"
                  >
                    Inbound
                  </NavLink>
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Ship/Outbound"
                  >
                    Outbound
                  </NavLink>

                  {/* {RoleData?.find((x) => x.ActionNo === "A047") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Ship/ContainerList"
                    >
                      Container List
                    </NavLink>
                  )} */}
                  {/* {RoleData?.find((x) => x.ActionNo === "A049") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Ship/ContainerTally"
                    >
                      Container TALLY
                    </NavLink>
                  )} */}
                </div>
              ) : null}
              {/* Container Repair */}
              {RoleData?.find((x) => x.ActionNo === "A089") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  // onClick={() => toggleNews(!OpenNews)}
                  onClick={() =>
                    dispatch(
                      toggleContainerRepairSidebar(!sidebarContainerRepairOpen)
                    )
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    construction
                  </span>
                  Container Repair
                  {sidebarContainerRepairOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarContainerRepairOpen ? (
                <div>
                  {RoleData?.find((x) => x.ActionNo === "A051") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/ContainerRepair/RepairList"
                    >
                      Repiar List
                    </NavLink>
                  )}
                </div>
              ) : null}
              {/* Financial */}
              {RoleData?.find((x) => x.ActionNo === "A090") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  // onClick={() => toggleNews(!OpenNews)}
                  onClick={() =>
                    dispatch(toggleFinancialSidebar(!sidebarFinancialOpen))
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    account_balance
                  </span>
                  Financial
                  {sidebarFinancialOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarFinancialOpen ? (
                <div>
                  {RoleData?.find((x) => x.ActionNo === "A057") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Financial/Dashboard"
                    >
                      Dashboard
                    </NavLink>
                  )}
                  {/* {RoleData?.find((x) => x.ActionNo === "A055") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Financial/Payment"
                    >
                      Payment
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A053") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Financial/Expense"
                    >
                      Expense
                    </NavLink>
                  )} */}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Financial/FinancialList"
                  >
                    Financial List
                  </NavLink>

                </div>
              ) : null}
              {/*Report Menu */}
              {RoleData?.find((x) => x.ActionNo === "A092") && (
                <NavLink
                  className="list-group-item list-group-item-action list-group-item-light p-3"
                  exact={true}
                  activeClassName="is-active"
                  to="/Report"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    trending_up
                  </span>
                  Report
                </NavLink>
              )}
              {/* Setting Menu */}
              {RoleData?.find((x) => x.ActionNo === "A091") && (
                <a
                  style={{ display: "flex", flexDirection: "row" }}
                  className="list-group-item list-group-item-action list-group-item-Menu p-3"
                  // href="#!"
                  // onClick={() => toggleNews(!OpenNews)}
                  onClick={() =>
                    dispatch(toggleSettingSidebar(!sidebarSetttingOpen))
                  }
                >
                  <span
                    style={{ marginRight: 10 }}
                    className="material-icons-outlined"
                  >
                    settings
                  </span>
                  Setting
                  {sidebarSetttingOpen ? (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      expand_more
                    </span>
                  ) : (
                    <span
                      style={{
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "end",
                      }}
                      className="material-icons-outlined"
                    >
                      chevron_right
                    </span>
                  )}
                </a>
              )}
              {sidebarSetttingOpen ? (
                <div>
                  {RoleData?.find((x) => x.ActionNo === "A058") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Company"
                    >
                      Company
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A060") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Branch"
                    >
                      Branch
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A062") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Employee"
                    >
                      Employee
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A072") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Liners"
                    >
                      Liners
                    </NavLink>
                  )}

                  {RoleData?.find((x) => x.ActionNo === "A074") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/FreightForwarder"
                    >
                      Freight Forwarder
                    </NavLink>
                  )}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/Vender"
                  >
                    Vender
                  </NavLink>
                  <Divider sx={{ marginLeft: "40px", marginRight: '40px' }} />
                  {RoleData?.find((x) => x.ActionNo === "A068") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Container"
                    >
                      Container
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A076") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Commodity"
                    >
                      Commodity
                    </NavLink>
                  )}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/Package"
                  >
                    Package
                  </NavLink>
                  <Divider sx={{ marginLeft: "40px", marginRight: '40px' }} />

                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/Currency"
                  >
                    Currency
                  </NavLink>
                  {RoleData?.find((x) => x.ActionNo === "A064") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Service"
                    >
                      Service
                    </NavLink>
                  )}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/Cost"
                  >
                    Cost
                  </NavLink>
                  <Divider sx={{ marginLeft: "40px", marginRight: '40px' }} />

                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/Country"
                  >
                    Country
                  </NavLink>
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/Location"
                  >
                    Location
                  </NavLink>
                  {RoleData?.find((x) => x.ActionNo === "A094") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Depots"
                    >
                      Depots
                    </NavLink>
                  )}
                    {RoleData?.find((x) => x.ActionNo === "A097") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Terminal"
                    >
                      Terminal
                    </NavLink>
                  )}
                  <Divider sx={{ marginLeft: "40px", marginRight: '40px' }} />

                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/inspectionStation"
                  >
                    Inspection Station
                  </NavLink>
                  {RoleData?.find((x) => x.ActionNo === "A112") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Incoterms"
                    >
                      Incoterms
                    </NavLink>
                  )}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/FreightTerms"
                  >
                    Freight Terms
                  </NavLink>
                  <Divider sx={{marginLeft:"40px", marginRight:'40px'}}/>

                  {/* {RoleData?.find((x) => x.ActionNo === "A066") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Transport"
                    >
                      Transport
                    </NavLink>
                  )} */}




                  {/* {RoleData?.find((x) => x.ActionNo === "A079") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/PolPod"
                    >
                      POL/POD
                    </NavLink>
                  )} */}

                
                  {RoleData?.find((x) => x.ActionNo === "A099") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Transhipment"
                    >
                      Transhipment
                    </NavLink>
                  )}
                  <NavLink
                    className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                    exact={true}
                    activeClassName="is-active"
                    to="/Setting/TrainRoute"
                  >
                    Train Route
                  </NavLink>
                  {RoleData?.find((x) => x.ActionNo === "A103") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Barge"
                    >
                      Barge
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A081") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Tuglist"
                    >
                      Tug
                    </NavLink>
                  )}

                  {RoleData?.find((x) => x.ActionNo === "A070") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Vehicle"
                    >
                      Vehicle
                    </NavLink>
                  )}
                  {/* {RoleData?.find((x) => x.ActionNo === "A105") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/Role"
                    >
                      Role
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A109") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/ManagePermissions"
                    >
                      Manage Permissions
                    </NavLink>
                  )}
                  {RoleData?.find((x) => x.ActionNo === "A107") && (
                    <NavLink
                      className="list-group-item list-group-item-action list-group-item-light p-3 SubMenu"
                      exact={true}
                      activeClassName="is-active"
                      to="/Setting/SetPermissions"
                    >
                      Set Permissions
                    </NavLink>
                  )} */}






                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
